import { Component, JSX } from 'solid-js';
import type {
  ControlDropdownProps,
  ControlDropdownShellContext,
} from './control-dropdown.types';
import { ControlDropdownShell } from './ControlDropdownShell';
import { AnchorIcon } from './AnchorIcon';

/**
 * Standard menu picker: clicking the anchor opens/closes the menu (or triggers
 * `onAnchorActiveClick` when active). For a split tool picker whose primary
 * button replays the last-used tool, use {@link SplitControlDropdown} instead.
 */
export const ControlDropdown: Component<ControlDropdownProps> = (props) => {
  const renderAnchor = (ctx: ControlDropdownShellContext): JSX.Element => {
    const handleAnchorClick = (): void => {
      if (props.isAnchorActive && props.onAnchorActiveClick) {
        props.onAnchorActiveClick();
        ctx.close();
        return;
      }
      ctx.toggle();
    };

    return (
      <section
        class={`${ctx.anchorSectionClass()}`}
        data-testid="control-dropdown-anchor"
        onClick={handleAnchorClick}
      >
        <button
          type="button"
          data-testid="control-dropdown-anchor-icon"
          class={`${ctx.anchorButtonHeightClass()} flex items-center justify-center cursor-pointer rounded-sm`}
        >
          <div class="items-center justify-center cursor-pointer rounded-sm pl-1 pr-0.5 flex flex-row gap-px">
            <AnchorIcon anchorIcon={props.anchorIcon} size={props.size} />
            <i
              class={`icon-font tc-icon-arrow-drop-down transition-all duration-300 ${
                ctx.isOpen() ? 'rotate-180' : ''
              }`}
            />
          </div>
        </button>
      </section>
    );
  };

  return (
    <ControlDropdownShell
      items={props.items}
      position={props.position}
      tooltip={props.tooltip}
      pressed={props.pressed}
      isAnchorActive={props.isAnchorActive}
      size={props.size}
      customAnchorSectionClasses={props.customAnchorSectionClasses}
    >
      {(ctx) => renderAnchor(ctx)}
    </ControlDropdownShell>
  );
};
